import React, { forwardRef } from 'react'
import './PromotionSearchBar.scss'
import { PROMOTION_SEARCH_PLACEHOLDER } from '../commonConstant'
import { SEARCH_REGEX } from '../../constants'

const PromotionSearchBar = forwardRef(({ searchInput, setSearchInput, placeholder = PROMOTION_SEARCH_PLACEHOLDER, handleSearchChange, handleSearchClick, regex = SEARCH_REGEX, minLength, maxLength }, ref) => {

    const handleChange = e => {
        if (regex) {
            if (regex.test(e.target.value)) {
                setSearchInput(e.target.value);
            } else {
                e.preventDefault();
            }
            handleSearchChange(e);
        } else {
            handleSearchChange(e);
        }
    }

    const clearSearchBar = () => {
        setSearchInput('');
    }

    return (
        <div className="promotion-search-input-container">
            <input type="text" value={searchInput} ref={ref} onClick={handleSearchClick} minLength={minLength} maxLength={maxLength} onChange={e => handleChange(e)} className="form-control search-input"
                placeholder={placeholder} />
            <img src="/images/promotion/icon-search-black.svg" className="search-img" />
        </div>
    )
})

export default PromotionSearchBar;